import React, { useEffect, useState } from 'react'
import { 
  ProjectOutlined,
  DollarCircleOutlined, 
  FieldTimeOutlined, 
  NotificationOutlined,
  ShopOutlined,
  MessageOutlined,
  DesktopOutlined,
  MailOutlined,
  SlidersOutlined,
  TabletOutlined
} from '@ant-design/icons';
import { Divider, MenuProps } from 'antd';
import { Menu } from 'antd';
import { sendSystemLog } from '../../context/AuthProvider/useAuth';
import ConfigPages from '../ConfigPages';

const items: MenuProps['items'] = [
  {
    label: 'Business Day',
    key: 'business_day',
    icon: <FieldTimeOutlined />,
  },
  {
    label: 'Features',
    key: 'features',
    icon: <ProjectOutlined />,
  },
  {
    label: 'Fees',
    key: 'fees',
    icon: <DollarCircleOutlined />,
  },
  {
    label: 'Notification',
    key: 'notification',
    icon: <NotificationOutlined />,
  },
  {
    label: 'MDOR Export',
    key: 'mdorExport',
    icon: <ShopOutlined />,
  },
  {
    label: 'Messaging',
    key: 'messaging',
    icon: <MessageOutlined />,
  },
  {
    label: 'Portal',
    key: 'portal',
    icon: <DesktopOutlined />,
  },
  {
    label: 'System',
    key: 'system',
    icon: <SlidersOutlined />,
  },
  {
    label: 'POS Drawer',
    key: 'posDrawer',
    icon: <TabletOutlined />,
  },
]

function index() {

  const [current, setCurrent] = useState('business_day');

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };

  return (
    <div className="config">
      <Menu style={{ backgroundColor: 'transparent' }} onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
      <div className={`config__page ${current === 'mdorExport' && 'no-padding'}`}>
        <Divider />
        <ConfigPages page={current} />
      </div>
    </div>
  )
}

export default index